module.exports = __webpack_public_path__ + "static/vmware_20.7a3b19c9.jpg";